module.exports = __webpack_public_path__ + "media/images/japan/location_0-c3e10e59192cc701c86f74b812004a58.png";